export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00016.23de8701.png";